import AuditApi from './audit/audit-api.vue'
import AuditLogs from './audit/audit-logs.vue'

const __default__ = {
  data() {
    return {
      active: 'audit-api',
    }
  },
  computed: {
    tabs() {
      return [
        {value: 'audit-api', title: 'Audit Api'},
        {value: 'audit-logs', title: 'Audit Logs'},
      ]
    } 
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'audit',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { AuditApi, AuditLogs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})